import { render, staticRenderFns } from "./List2x2.vue?vue&type=template&id=7820c86a&scoped=true&"
import script from "./List2x2.vue?vue&type=script&lang=ts&"
export * from "./List2x2.vue?vue&type=script&lang=ts&"
import style0 from "./List2x2.vue?vue&type=style&index=0&id=7820c86a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820c86a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
